import React, { FC } from 'react';

const ChessGuide: FC = () => {
  return (
    <>
      <p>
        <span>Chess</span> - the classic two-player game. Standard rules apply.
      </p>

      <img src={'./static/public/media/chess_cover.svg'} alt="Chess board" style={{ maxWidth: '320px' }} />

      <p>On your turn, click one of your pieces to see its legal moves, then click a highlighted square to move there.</p>
      <p>You can try different moves before committing - selecting another piece resets the previous one, or use Reset. Press Submit to make your move.</p>
      <p>Checkmate wins the game. Stalemate or insufficient material is a draw.</p>
    </>
  );
};

export default ChessGuide;
